webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var oldGuests = [{ 'name': 'QasarYounis', 'title': 'Y Combinator', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/qasar.png' }, { 'name': 'Ashish Sharma', 'title': 'Paytm', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/ashish.png' }, { 'name': 'Vikas Banga', 'title': 'Snapdeal', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/vikas.png' }, { 'name': 'Ophir Gore', 'title': '以色列驻华使馆', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/ophir.png' }, { 'name': 'Dovi Ollech', 'title': 'E.MERGR Fund', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/dovi.png' }, { 'name': 'Justin Kan', 'title': 'Y Combinator', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/justin.png' }, { 'name': '张颖', 'title': '经纬中国', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/zhangying.png' }, { 'name': '朱啸虎', 'title': '金沙江创投', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/zhuxiaohu.png' }, { 'name': '戴威', 'title': 'ofo共享单车', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/daiwei.png' }, { 'name': '吴海燕', 'title': '华创资本', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/wuhaiyan2.png' }, { 'name': '宿华', 'title': '快手', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/suhua.png' }, { 'name': '肖文杰', 'title': '分期乐', 'img': 'http://static-image.xfz.cn/explore/images/xfz2017/xiaowenjie.png' }];
/* harmony default export */ __webpack_exports__["a"] = (oldGuests);

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);


var util = {
    resource: function resource(options) {
        if (!options.data) {
            options.data = {};
        }
        if (!options.method) {
            options.method = 'get';
        }
        if (options.method == 'get') {
            options.data = {
                params: options.data
            };
        }
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http[options.method](options.url, options.data).then(function (res) {
            return res.json();
        }).then(function (res) {
            options.success(res);
        });
    },

    getWx: function getWx() {
        var _this = this;
        var data = {
            url: location.href,
            csrfmiddlewaretoken: $('.login-container input').val()
        };
        $.ajax({
            url: '/api/website/signature/weixin/',
            type: 'post',
            data: data,
            success: function success(res) {
                _this.callBack(res.data);
            }
        });
    },

    callBack: function callBack(data) {
        var wxurl = location.href;
        var wxtitle = "2018不凡商业全球青年创业者大会于11月14、15日隆重举办，全球顶级创投大佬分享创业经验，邀你一起探讨未来！";
        var wxdes = "举办时间：11月14、15日；活动地点：北京 万达文化大酒店";
        var wximg = "https://static-image.xfz.cn/bufan-share-logo-300.png";

        wx.config({
            debug: false,
            appId: data.app_id,
            timestamp: data.timestamp,
            nonceStr: data.noncestr,
            signature: data.signature,
            jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage']
        });
        wx.ready(function () {
            wx.onMenuShareTimeline({
                title: wxtitle,
                link: wxurl,
                imgUrl: wximg,
                desc: wxdes,
                success: function success() {},
                cancel: function cancel() {}
            });
            wx.onMenuShareAppMessage({
                title: wxtitle,
                link: wxurl,
                imgUrl: wximg,
                desc: wxdes,
                type: '',
                dataUrl: '',
                success: function success() {},
                cancel: function cancel() {}
            });
        });
    }
};
/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/award1.cfbe1bd.jpg";

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/award2.f106ddf.jpg";

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/award3.cbb55ce.jpg";

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/award4.7a2b779.jpg";

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/live-logo.7743d72.png";

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jim.f306a5e.png";

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qasar.c4d0d5a.png";

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tuobuhua.3fbf07c.png";

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/xiaowenjie.31dbe60.png";

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zhangying.f290727.png";

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(29)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(19),
  /* template */
  __webpack_require__(55),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TopSection__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TopSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_TopSection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HomePc__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HomePc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_HomePc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HomeMobile__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HomeMobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_HomeMobile__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    TopSection: __WEBPACK_IMPORTED_MODULE_0__components_TopSection___default.a,
    HomePc: __WEBPACK_IMPORTED_MODULE_1__components_HomePc___default.a,
    HomeMobile: __WEBPACK_IMPORTED_MODULE_2__components_HomeMobile___default.a
  },
  methods: {
    isPc: function isPc() {
      return screen.width > 800 ? true : false;
    }
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['data', 'index']
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MobileAgendaItem__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MobileAgendaItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__MobileAgendaItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MobileTicketItem__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MobileTicketItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MobileTicketItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_guest_data__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    AgendaItem: __WEBPACK_IMPORTED_MODULE_0__MobileAgendaItem___default.a,
    TicketItem: __WEBPACK_IMPORTED_MODULE_1__MobileTicketItem___default.a
  },
  data: function data() {
    return {
      whichDay: "Day1",
      showMenu: false,
      guestList: [],
      agendaData: {
        type: []
      },
      whichConf: "",
      whichHost: "",
      partnerList: [],
      currentAgendaMenu: [],
      activeAgendaMenu: "",
      currentAgendaData: [],
      showMoreFaq: false,
      showBottomNav: true,
      oldScrollY: 0,
      newScrollY: 0,
      oldGuests: __WEBPACK_IMPORTED_MODULE_3__assets_js_guest_data__["a" /* default */],
      ticketUrl: "https://www.bufanbiz.com/apply/conference/?code=FskyfwKLMm"
    };
  },

  methods: {
    addListenScroll: function addListenScroll() {
      var self = this;
      window.onscroll = function (e) {
        self.newScrollY = window.scrollY;
        if (self.newScrollY - self.oldScrollY > 0) {
          self.showBottomNav = false;
        } else {
          self.showBottomNav = true;
        }
        self.oldScrollY = self.newScrollY;
      };
    },
    getGuestData: function getGuestData() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_2__assets_js_util__["a" /* default */].resource({
        url: "/explore/bufan2018_api/guest/",
        method: "get",
        success: function success(res) {
          if (res.code == 200) {
            self.guestList = res.data;
          }
        }
      });
    },
    getPartnerData: function getPartnerData() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_2__assets_js_util__["a" /* default */].resource({
        url: "/explore/bufan2018_api/company/",
        method: "get",
        success: function success(res) {
          if (res.code == 200) {
            self.partnerList = res.data;
          }
        }
      });
    },
    getAgendaData: function getAgendaData() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_2__assets_js_util__["a" /* default */].resource({
        url: "/explore/bufan2018_api/meeting/",
        method: "get",
        success: function success(res) {
          if (res.code == 200) {
            self.agendaData = res.data;
            self.currentAgendaMenu = self.agendaData.type[0] ? self.agendaData.type[0] : [];
            self.activeAgendaMenu = self.agendaData.type[0][0];
            self.changeCurrentAgenda(self.activeAgendaMenu);
          }
        }
      });
    },
    changeCurrentAgenda: function changeCurrentAgenda(agenda) {
      this.activeAgendaMenu = agenda;
      this.currentAgendaData = this.agendaData.meeting[agenda];
      this.whichConf = agenda.split("|")[0];
      this.whichHost = agenda.split("|")[1];
    },
    gotoSection: function gotoSection(section) {
      $("html,body").animate({ scrollTop: $("#" + section).offset().top }, 1000);
    }
  },
  mounted: function mounted() {
    document.title = '2018不凡商业全球青年创业者大会！_不凡商业';
    this.addListenScroll();
    this.getGuestData();
    this.getAgendaData();
    this.getPartnerData();
    __WEBPACK_IMPORTED_MODULE_2__assets_js_util__["a" /* default */].getWx();
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AgendaItem__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AgendaItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AgendaItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TicketItem__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TicketItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TicketItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_guest_data__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        AgendaItem: __WEBPACK_IMPORTED_MODULE_0__AgendaItem___default.a, TicketItem: __WEBPACK_IMPORTED_MODULE_1__TicketItem___default.a
    },
    data: function data() {
        return {
            showNav: true,
            showAgendaMenu: false,
            showAgendaMenu2: true,
            guestList: [],
            partnerList: [],
            agendaData: {
                meeting: {},
                type: []
            },
            whichConf: '',
            whichHost: '',
            currentAgendaData: [],
            activeAgendaMenu: '',
            activeAgendaMenuIndex: 0,
            showMoreFaq: false,
            oldGuests: __WEBPACK_IMPORTED_MODULE_3__assets_js_guest_data__["a" /* default */],
            ticketUrl: "https://www.bufanbiz.com/apply/conference/?code=FskyfwKLMm"
        };
    },

    methods: {
        getGuestData: function getGuestData() {
            var self = this;
            __WEBPACK_IMPORTED_MODULE_2__assets_js_util__["a" /* default */].resource({
                url: '/explore/bufan2018_api/guest/',
                method: 'get',
                success: function success(res) {
                    if (res.code == 200) {
                        self.guestList = res.data;
                    }
                }
            });
        },
        getPartnerData: function getPartnerData() {
            var self = this;
            __WEBPACK_IMPORTED_MODULE_2__assets_js_util__["a" /* default */].resource({
                url: '/explore/bufan2018_api/company/',
                method: 'get',
                success: function success(res) {
                    if (res.code == 200) {
                        self.partnerList = res.data;
                    }
                }
            });
        },
        getAgendaData: function getAgendaData() {
            var self = this;
            __WEBPACK_IMPORTED_MODULE_2__assets_js_util__["a" /* default */].resource({
                url: '/explore/bufan2018_api/meeting/',
                method: 'get',
                success: function success(res) {
                    if (res.code == 200) {
                        self.agendaData = res.data;
                        self.activeAgendaMenu = self.agendaData.type[0][0];
                        self.changeCurrentAgenda(self.activeAgendaMenu, 0);
                    }
                }
            });
        },
        changeCurrentAgenda: function changeCurrentAgenda(agenda, index) {
            this.whichConf = agenda.split('|')[0];
            this.whichHost = agenda.split('|')[1];
            this.activeAgendaMenu = agenda;
            this.activeAgendaMenuIndex = index;
            this.currentAgendaData = this.agendaData.meeting[agenda];
        },
        gotoAgenda: function gotoAgenda(date) {
            location.href = "#s-agenda";
            if (date == 'date1') {
                this.changeCurrentAgenda(this.agendaData.type[0][0], 0);
            } else if (date == 'data2') {
                this.changeCurrentAgenda(this.agendaData.type[1][0], 4);
            }
        },
        gotoVipAgenda: function gotoVipAgenda(title) {
            this.whichConf = title.split('|')[0];
            this.whichHost = title.split('|')[1];
            this.changeCurrentAgenda(this.agendaData.type[0][4]);
        },
        listenScroll: function listenScroll() {
            var self = this;
            var offset = $('#participator-area').offset().top + 200;
            var flag = true;
            $(window).scroll(function () {
                var scrollTop = $(window).scrollTop();
                if (scrollTop > offset) {
                    if (flag) {
                        self.runCountUp();
                        flag = false;
                    }
                }
            });
        },
        runCountUp: function runCountUp() {
            var options = {
                useEasing: true,
                useGrouping: true,
                separator: ',',
                decimal: '.',
                suffix: '+'
            };
            var countup1 = new CountUp('countup-target1', 0, 5000, 0, 3.5, options);
            var countup2 = new CountUp('countup-target2', 0, 100, 0, 3.5, options);
            var countup3 = new CountUp('countup-target3', 0, 50, 0, 3.5, options);
            var countup4 = new CountUp('countup-target4', 0, 4, 0, 3.5, options);
            var countup5 = new CountUp('countup-target5', 0, 60, 0, 3.5, options);
            var countup6 = new CountUp('countup-target6', 0, 150, 0, 3.5, options);
            if (!countup1.error) {
                countup1.start();
                countup2.start();
                countup3.start();
                countup4.start();
                countup5.start();
                countup6.start();
            } else {
                console.error(demo.error);
            }
        }
    },
    mounted: function mounted() {
        document.title = '2018不凡商业全球青年创业者大会！_不凡商业';
        this.getGuestData();
        this.getPartnerData();
        this.getAgendaData();
        this.listenScroll();
    }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["data", "index"]
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
   props: ['data']
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
   props: ['data']
});

/***/ }),
/* 26 */
/***/ (function(module, exports) {



/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(18);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 28 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 29 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 32 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 33 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 34 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 35 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/map.191edcb.png";

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner.1095e89.png";

/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/map.11900de.png";

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/more.535e4b8.png";

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/m-rogers.4c4e82b.png";

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pc-rogers.2c48bf4.png";

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(35)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(20),
  /* template */
  __webpack_require__(61),
  /* scopeId */
  "data-v-eb5a1a80",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(31)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(21),
  /* template */
  __webpack_require__(57),
  /* scopeId */
  "data-v-40bd7ae2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(28)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(22),
  /* template */
  __webpack_require__(54),
  /* scopeId */
  "data-v-070f089a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(30)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(23),
  /* template */
  __webpack_require__(56),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(34)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(60),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(32)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(58),
  /* scopeId */
  "data-v-521b41c0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(33)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(59),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home-pc"
    }
  }, [_c('div', {
    staticClass: "header-wrap",
    attrs: {
      "id": "header-wrap-id"
    }
  }, [_c('a', {
    attrs: {
      "id": "s-summary"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNav),
      expression: "showNav"
    }],
    staticClass: "nav"
  }, [_c('ul', [_c('img', {
    staticClass: "menu-logo",
    attrs: {
      "src": __webpack_require__(39),
      "alt": ""
    }
  }), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-summary"
    }
  }, [_vm._v("首页")])]), _vm._v(" "), (false) ? _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#past-guest"
    }
  }, [_vm._v("往期嘉宾")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-guest"
    }
  }, [_vm._v("确定嘉宾")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-agenda"
    }
  }, [_vm._v("大会议程")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-award"
    }
  }, [_vm._v("奖项评选")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-tickets"
    }
  }, [_vm._v("参会购票")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "https://www.bufanbiz.com/explore/bufan2018/news/",
      "target": "_blank"
    }
  }, [_vm._v("大会直播")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-partners"
    }
  }, [_vm._v("合作机构")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-contact-us"
    }
  }, [_vm._v("联系我们")])])])])])], 1), _vm._v(" "), (false) ? _c('div', {
    staticClass: "section past-guest",
    attrs: {
      "id": "past-guest"
    }
  }, [_c('p', {
    attrs: {
      "id": "s-past-guest"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "guest-bg-area"
    }
  }, [_c('div', {
    staticClass: "section guest",
    attrs: {
      "id": "guest-wrap-id"
    }
  }, [_c('p', {
    attrs: {
      "id": "s-guest"
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "guest-list"
  }, _vm._l((_vm.guestList), function(guest, index) {
    return _c('li', [_c('div', {
      staticClass: "photo"
    }, [_c('div', {
      staticClass: "left-top"
    }), _vm._v(" "), _c('img', {
      attrs: {
        "src": guest.photo,
        "alt": "嘉宾姓名"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "right-bottom"
    })]), _vm._v(" "), _c('div', {
      staticClass: "name-wrap"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(guest.name))]), _vm._v(" "), _c('div', {
      staticClass: "company"
    }, [_vm._v(_vm._s(guest.position))])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "section agenda"
  }, [_c('p', {
    attrs: {
      "id": "s-agenda"
    }
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(false) ? _c('div', {
    class: _vm.showagendamenu ? 'agenda-menu' : 'agenda-menu2'
  }, [_c('div', {
    staticClass: "date",
    on: {
      "click": function($event) {
        _vm.gotoagenda('date1')
      }
    }
  }), _vm._v(" "), (_vm.agendadata.type && _vm.agendadata.type[0] && _vm.agendadata.type[0].length > 0) ? [_vm._l((_vm.agendadata.type[0]), function(item, index) {
    return [(index < 4) ? [_c('div', {
      staticClass: "item ",
      class: [{
        'active-agenda-menu': _vm.activeagendamenu == item
      }, 'bg-color-' + index],
      on: {
        "mouseover": function($event) {
          _vm.changecurrentagenda(item, index)
        },
        "click": function($event) {
          _vm.changecurrentagenda(item, index)
        }
      }
    }, [_vm._v("\n                                " + _vm._s(item.split('|')[0]) + "\n                            ")])] : _vm._e()]
  })] : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _vm._l((_vm.agendaData.type[0]), function(type, index) {
    return [_c('div', {
      class: 'agenda-group-' + index
    }, [_c('div', {
      staticClass: "agenda-group-center",
      class: 'agenda-group-center-' + index
    }, [_c('div', {
      staticClass: "conf-host",
      class: 'agenda-theme-' + index
    }, [_c('div', {
      staticClass: "which-conf"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(type)
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "see-map",
      attrs: {
        "href": "http://j.map.baidu.com/h4z9P",
        "target": "_blank"
      }
    }, [_vm._v("查看地图")])])]), _vm._v(" "), _c('div', {
      staticClass: "agenda-list"
    }, [_vm._l((_vm.agendaData.meeting[type]), function(agenda, index) {
      return [_c('agenda-item', {
        attrs: {
          "data": agenda,
          "index": index
        }
      })]
    })], 2)])])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "section agenda"
  }, [_vm._l((_vm.agendaData.type[1]), function(type, index) {
    return [_c('div', {
      class: 'agenda-group-' + index
    }, [_c('div', {
      staticClass: "agenda-group-center",
      class: 'agenda-group-center-' + index
    }, [_c('div', {
      staticClass: "conf-host",
      class: 'agenda-theme-' + index
    }, [_c('div', {
      staticClass: "which-conf"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(type)
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "see-map",
      attrs: {
        "href": "http://j.map.baidu.com/h4z9P",
        "target": "_blank"
      }
    }, [_vm._v("查看地图")])])]), _vm._v(" "), _c('div', {
      staticClass: "agenda-list"
    }, [_vm._l((_vm.agendaData.meeting[type]), function(agenda, index) {
      return [_c('agenda-item', {
        attrs: {
          "data": agenda,
          "index": index
        }
      })]
    })], 2)])])]
  })], 2), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    attrs: {
      "id": "tickets-bg-area"
    }
  }, [_c('div', {
    staticClass: "section tickets"
  }, [_c('p', {
    attrs: {
      "id": "s-tickets"
    }
  }), _vm._v(" "), _vm._m(6), _vm._v(" "), (false) ? _c('a', {
    staticClass: "rogers-area",
    attrs: {
      "href": "https://jinshuju.net/f/Jlf1js",
      "target": "_blank"
    }
  }, [_vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "buy-btn"
  }), _vm._v(" "), _c('div', {
    staticClass: "rogers-tickets"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tickets-content"
  }, [_c('a', {
    staticClass: "ticket3",
    attrs: {
      "href": _vm.ticketUrl,
      "target": "_blank"
    }
  }, [_vm._m(9)]), _vm._v(" "), _c('a', {
    staticClass: "ticket0",
    attrs: {
      "href": _vm.ticketUrl,
      "target": "_blank"
    }
  }, [_vm._m(10)]), _vm._v(" "), _c('a', {
    staticClass: "ticket1",
    attrs: {
      "href": _vm.ticketUrl,
      "target": "_blank"
    }
  }, [_vm._m(11)]), _vm._v(" "), _c('a', {
    staticClass: "ticket2",
    attrs: {
      "href": _vm.ticketUrl,
      "target": "_blank"
    }
  }, [_vm._m(12)]), _vm._v(" "), (false) ? _c('a', {
    staticClass: "ticket3",
    attrs: {
      "href": _vm.ticketUrl,
      "target": "_blank"
    }
  }, [_vm._m(13)]) : _vm._e()])])]), _vm._v(" "), (false) ? _c('div', {
    attrs: {
      "id": "old-guest-bg-area"
    }
  }, [_c('div', {
    staticClass: "section old-guests"
  }, [_c('p', {
    attrs: {
      "id": "s-old-guest"
    }
  }), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, _vm._l((_vm.oldGuests), function(item) {
    return _c('div', {
      staticClass: "old-guest-item"
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "guest-name"
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "guest-title"
    }, [_vm._v(_vm._s(item.title))])])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "faq-bg-area"
    }
  }, [_c('div', {
    staticClass: "section faq"
  }, [_c('p', {
    attrs: {
      "id": "s-faq"
    }
  }), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "faq-item"
  }, [_vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), (false) ? _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            是否可以团体购票？\n                        ")])]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            在小饭桌大会官网购票，一次订购5张及以上享受9折优惠；一次购买10张及以上享受8折优惠。\n                        ")])]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            是否可以申请发票？\n                        ")])]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _vm._m(20)]) : _vm._e(), _vm._v(" "), _vm._m(21), _vm._v(" "), (_vm.showMoreFaq) ? [_vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27)] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "faq-more-btn",
    on: {
      "click": function($event) {
        _vm.showMoreFaq = !_vm.showMoreFaq
      }
    }
  }, [(!_vm.showMoreFaq) ? _c('span', [_vm._v("查看更多")]) : _c('span', [_vm._v("点击收起")])])], 2)])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "partners-bg-area"
    }
  }, [_c('div', {
    staticClass: "section partners"
  }, [_c('p', {
    attrs: {
      "id": "s-partners"
    }
  }), _vm._v(" "), _vm._m(28), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('dl', [_vm._l((_vm.partnerList), function(partner) {
    return [_vm._l((partner), function(val, key) {
      return [_c('dt', [_vm._v(_vm._s(key))]), _vm._v(" "), _c('dd', _vm._l((val), function(pic) {
        return _c('img', {
          attrs: {
            "src": pic.logo + '-fintech.partner'
          }
        })
      }))]
    })]
  })], 2)])])]), _vm._v(" "), _vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "en"
  }, [_vm._v(" PAST GUEST")]), _vm._v(" "), _c('div', {
    staticClass: "zh"
  }, [_vm._v(" 往期嘉宾")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/5069.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(11)
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "play-btn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/5072.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "play-btn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/5078.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(13)
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "play-btn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/1897.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(12)
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "play-btn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/1916.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(14)
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "play-btn",
    attrs: {
      "src": __webpack_require__(1)
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "en"
  }, [_vm._v("GUESTS")]), _vm._v(" "), _c('div', {
    staticClass: "zh"
  }, [_vm._v("确定嘉宾")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "16px",
      "padding-left": "20px"
    }
  }, [_vm._v("排名不分先后")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "en"
  }, [_vm._v(" AGENDA ")]), _vm._v(" "), _c('div', {
    staticClass: "zh"
  }, [_vm._v(" 大会议程 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "award-area"
    }
  }, [_c('p', {
    attrs: {
      "id": "s-award"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "section award"
  }, [_c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "en"
  }, [_vm._v(" AWARD ")]), _vm._v(" "), _c('div', {
    staticClass: "zh"
  }, [_vm._v(" 奖项评选 ")])]), _vm._v(" "), _c('div', {
    staticClass: "award-content"
  }, [_c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/explore/2018vote/#!/topstartups",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6)
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/explore/2018vote/#!/topvc",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(7)
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/explore/2018vote/#!/topinvestorunder30",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(8)
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/explore/2018vote/#!/topinvestorunder40",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(9)
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "participator-area"
    }
  }, [_c('div', {
    staticClass: "section tickets"
  }, [_c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "en"
  }, [_vm._v(" SAFF ANALYSIS ")]), _vm._v(" "), _c('div', {
    staticClass: "zh"
  }, [_vm._v(" 参会人群分析")])]), _vm._v(" "), _c('div', {
    staticClass: "participator-content"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("确定嘉宾")]), _vm._v(" "), _c('div', {
    staticClass: "count",
    attrs: {
      "id": "countup-target1"
    }
  }, [_vm._v(" 0+")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("演讲嘉宾")]), _vm._v(" "), _c('div', {
    staticClass: "count",
    attrs: {
      "id": "countup-target2"
    }
  }, [_vm._v(" 0+")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("会议嘉宾")]), _vm._v(" "), _c('div', {
    staticClass: "count",
    attrs: {
      "id": "countup-target3"
    }
  }, [_vm._v(" 0+")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("榜单")]), _vm._v(" "), _c('div', {
    staticClass: "count",
    attrs: {
      "id": "countup-target4"
    }
  }, [_vm._v("  0+")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("参展企业")]), _vm._v(" "), _c('div', {
    staticClass: "count",
    attrs: {
      "id": "countup-target5"
    }
  }, [_vm._v(" 0+")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("媒体")]), _vm._v(" "), _c('div', {
    staticClass: "count",
    attrs: {
      "id": "countup-target6"
    }
  }, [_vm._v(" 0+")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "en"
  }, [_vm._v(" TICKETS ")]), _vm._v(" "), _c('div', {
    staticClass: "zh"
  }, [_vm._v(" 参会购票 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rogers"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(46)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ticket-info"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                        尊享票\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "price-line"
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v(" 36666元 ")]), _vm._v(" "), _c('span', [_vm._v(" 限10位名额，需审核")])]), _vm._v(" "), _c('div', {
    staticClass: "intro-line"
  }, [_vm._v("\n                        与国际著名投资大师吉姆·罗杰斯半天闭门沟通会 "), _c('br'), _vm._v("\n                        SSVIP尊享座位，2天通票，尽享4场论坛，20+主题演讲 "), _c('br'), _vm._v("\n                        闭门晚宴入场券，与全球最强创投大脑亲密social "), _c('br'), _vm._v("\n                        限企业/投资机构创始人、高管报名，需要审核 "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ticket-item"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                            限时优惠票\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_vm._v("\n                          9.9元 \n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            2天通票，尽享3场论坛（主论坛除外），15+主题演讲 "), _c('br'), _vm._v("\n                            4000屏幕展览互动体验 "), _c('br'), _vm._v("\n                            限时特惠，数量有限 "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "seat"
  }, [_vm._v("\n                            座位先到先得\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "buy-btn"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ticket-item"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                            早鸟参会票\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_vm._v("\n                          99元 \n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            2天通票，尽享4场论坛，20+主题演讲\u2028 "), _c('br'), _vm._v("\n                            4000平米展览互动体验 "), _c('br'), _vm._v("\n                            座位先到先得"), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "seat"
  }, [_vm._v("\n                          有限席位\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "buy-btn"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ticket-item"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                          2天峰会通票\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_vm._v("\n                          299元 \n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            2天通票，尽享4场论坛，20+主题演讲 "), _c('br'), _vm._v("\n                            \u20284000平米展览互动体验 "), _c('br'), _vm._v("\n                            座位先到先得 "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "seat"
  }, [_vm._v("\n                          有限席位\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "buy-btn"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ticket-item"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                          CEO票\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_vm._v("\n                          999元 \n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                          2天通票，尽享4场论坛，20+主题演讲 "), _c('br'), _vm._v("\n                          4000平米展览互动体验"), _c('br'), _vm._v("\n                          保证前排座位"), _c('br'), _vm._v("\n                          演讲嘉宾可公开 PPT 独家分享"), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "seat"
  }, [_vm._v("\n                          有限席位，仅限 CEO 参加\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "buy-btn"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ticket-item"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                          晚宴入场券\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_vm._v("\n                          9999元 \n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            闭门晚宴入场券"), _c('br'), _vm._v("\n                            将有机会与全球最强创投大脑"), _c('br'), _vm._v("\n                            亲密social "), _c('br'), _vm._v("\n                            CEO 票所有权益"), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "seat"
  }, [_vm._v("\n                          有限席位，报名需审核\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "buy-btn"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(16)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "en"
  }, [_vm._v(" FAQ ")]), _vm._v(" "), _c('div', {
    staticClass: "zh"
  }, [_vm._v(" 参会指南 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            购票什么时候截止?\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            购票截止日期为2018年11月12日。\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            购票付款成功后，如何获得参会凭证？\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            在您成功付款后，您将收到短信提醒，内容包含参会信息及电子票二维码，活动时凭电子票二维码入场。 "), _c('br'), _vm._v("\n                            活动开始前一周，还会短信发送一次参会信息。如果您关注了不凡商业（微信号：bufanbiz），届时也会有相应的提醒。\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            当您的购票订单付款成功后，会有相应的申请发票入口。也可 "), _c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": "http://www.xfz.cn/order/",
      "target": "_blank"
    }
  }, [_vm._v("点此申请发票")]), _vm._v("，在相应的订单下方点击申请发票即可。\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-a"
  }, [_c('div', {
    staticClass: "sa-title"
  }, [_vm._v("温馨提示：")]), _vm._v(" "), _c('div', {
    staticClass: "sa-content"
  }, [_vm._v("\n                            1) 大会门票仅开具增值税普通发票，不提供增值税专用发票；"), _c('br'), _vm._v("\n                            2) 开票内容为：会议服务费 "), _c('br'), _vm._v("\n                            3) 因本公司每月增值税普通发票数量有限，将以申请开票的先后顺序开具并安排快递，不保证当月开票，请谅解。"), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            观众座位是否有预留？会议现场是否需要对号入座，会议中途离开，座位是否保留？\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            请您核对票务权益，早鸟票、峰会通票用户根据进场顺序安排，不确保坐席，如您中途离开会场，不确保保留座位。\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            大会现场有同声传译服务吗？如何领取同传设备？\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            有，活动当天请凭借本人身份证，到指定地点换区同传设备，活动结束后，请及时归还同传设备并取回身份证。\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            大会场馆附近有就餐的地方吗？\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            酒店6层设有自助餐厅；距会场2-7分钟，步行即可到达诸多卖场，中餐、西餐、港式餐厅等，价位不等，有多样选择。\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "en"
  }, [_vm._v(" PARTNERS ")]), _vm._v(" "), _c('div', {
    staticClass: "zh"
  }, [_vm._v(" 合作机构 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section location"
  }, [_c('p', {
    attrs: {
      "id": "s-location"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "en"
  }, [_vm._v(" ADDRESS ")]), _vm._v(" "), _c('div', {
    staticClass: "zh"
  }, [_vm._v(" 会议地址 ")])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "location-wrap"
  }, [_c('div', {
    staticClass: "address-info"
  }, [_c('div', [_vm._v("\n                        会场地址：国贸站 G 东南口出，890 米即到\n                    ")]), _vm._v(" "), _c('div', [_vm._v("\n                        地铁路线：大望路站 D 西北口出，649 米即到\n                    ")]), _vm._v(" "), _c('div', [_vm._v("\n                        驾车路线：北京市朝阳区建外大街建国路93号万达广场 C 座\n                    ")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(40),
      "alt": ""
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section about-us"
  }, [_c('p', {
    attrs: {
      "id": "s-contact-us"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "en"
  }, [_vm._v(" CONTACT US")]), _vm._v(" "), _c('div', {
    staticClass: "zh"
  }, [_vm._v(" 联系我们 ")])]), _vm._v(" "), _c('div', {
    staticClass: "about-us-wrap"
  }, [_c('div', {
    staticClass: "user-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("赞助合作")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("李成坤")]), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_vm._v("138-1187-2225")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_vm._v("chengkun@bufanbiz.com")])]), _vm._v(" "), _c('div', {
    staticClass: "user-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("媒体合作")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("赵子悠")]), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_vm._v("185-4513-1578")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_vm._v("zhaobo@bufanbiz.com")])]), _vm._v(" "), _c('div', {
    staticClass: "user-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("报名咨询")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("罗阳")]), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_vm._v("188-1179-5758")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_vm._v("luoyang@bufanbiz.com")])]), _vm._v(" "), _c('div', {
    staticClass: "qrcode"
  }, [_c('img', {
    attrs: {
      "src": "https://www.bufanbiz.com/static/build/images/footer-wx-share.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "qrcode-info"
  }, [_c('span', [_vm._v("扫描二维码"), _c('br'), _vm._v(" 关注不凡商业")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom-buy-link-float"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "https://www.bufanbiz.com/explore/bufan2018/news/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(10)
    }
  })])])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.isPc()) ? _c('home-pc') : _c('home-mobile')], 1)
},staticRenderFns: []}

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['m-agenda-item', {
      'm-agenda-item-bg-reverse': _vm.index % 2 == 0
    }]
  }, [_c('div', {
    staticClass: "item-wrap",
    class: {
      'item-wrap-small': _vm.data.speaker.length == 0
    }
  }, [_c('div', {
    staticClass: "agenda-title"
  }, [_c('div', {
    staticClass: "t-name"
  }, [_c('div', [_vm._v(_vm._s(_vm.data.time.split('~')[0]))]), _vm._v(" "), _c('div', [_vm._v("~")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.data.time.split('~')[1]))])])]), _vm._v(" "), _c('div', {
    staticClass: "a-content"
  }, [_c('div', {
    staticClass: "a-content-wrap"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "subject-type"
  }, [_vm._v(_vm._s(_vm.data.subject.split('|')[0]))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "subject-title"
  }, [_vm._v(_vm._s(_vm.data.subject.split('|')[1]))])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [(_vm.data.speaker[0] && _vm.data.speaker[0].photo) ? _c('div', {
    staticClass: "name-title"
  }, [_c('div', {
    staticClass: "photo"
  }, [_c('img', {
    attrs: {
      "src": _vm.data.speaker[0].photo
    }
  })])]) : _vm._e()])])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "divider-line"
  }) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home-mobile"
    }
  }, [_c('a', {
    attrs: {
      "name": "s-home",
      "id": "s-home"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "just-a-wrap"
  }, [_c('div', {
    staticClass: "banner",
    attrs: {
      "id": "section-banner"
    }
  }, [_c('img', {
    staticClass: "banner-img",
    attrs: {
      "src": __webpack_require__(41)
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(false) ? _c('div', {
    staticClass: "nav"
  }, [_c('ul', [_c('li', {
    on: {
      "click": function($event) {
        _vm.gotoSection('s-home')
      }
    }
  }, [_c('a', [_vm._v("首页")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "/explore/2017cusc/news/",
      "target": "_blank"
    }
  }, [_vm._v("大会现场")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.gotoSection('s-guest')
      }
    }
  }, [_c('a', [_vm._v("确认嘉宾")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.gotoSection('s-agenda')
      }
    }
  }, [_c('a', [_vm._v("会议议程")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.gotoSection('s-tickets')
      }
    }
  }, [_c('a', [_vm._v("参会购票")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.gotoSection('s-partners')
      }
    }
  }, [_c('a', [_vm._v("合作机构")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.gotoSection('s-location')
      }
    }
  }, [_c('a', [_vm._v("场地信息")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.gotoSection('s-contact-us')
      }
    }
  }, [_c('a', [_vm._v("联系我们")])])])]) : _vm._e()])], 1), _vm._v(" "), (false) ? _c('div', {
    staticClass: "section past-guest",
    attrs: {
      "id": "past-guest"
    }
  }, [_c('p', {
    attrs: {
      "id": "s-past-guest"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section guest",
    attrs: {
      "id": "section-guest"
    }
  }, [_c('a', {
    attrs: {
      "id": "s-guest"
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "guest-list"
  }, _vm._l((_vm.guestList), function(guest) {
    return _c('li', [_c('div', {
      staticClass: "photo"
    }, [_c('img', {
      attrs: {
        "src": guest.photo,
        "alt": "嘉宾姓名"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "name-wrap"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(guest.name))]), _vm._v(" "), _c('div', {
      staticClass: "company"
    }, [_c('div', {
      staticClass: "position"
    }, [_vm._v("\n                                " + _vm._s(guest.position) + "\n                            ")])])])])
  }))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "agenda-bg-area"
    }
  }, [_c('div', {
    staticClass: "section agenda",
    attrs: {
      "id": "section-agenda"
    }
  }, [_c('a', {
    attrs: {
      "id": "s-agenda"
    }
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), (_vm.agendaData.type[0]) ? _vm._l((_vm.agendaData.type[0]), function(key, index) {
    return _c('div', {
      class: 'agenda-item-' + index
    }, [_c('div', {
      staticClass: "conf-host",
      class: 'conf-host-' + index
    }, [_c('div', {
      staticClass: "title"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(key)
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "agenad-list"
    }, [_vm._l((_vm.agendaData.meeting[key]), function(agenda, index) {
      return [_c('agenda-item', {
        attrs: {
          "data": agenda,
          "index": index
        }
      })]
    })], 2)])
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "section agenda",
    attrs: {
      "id": "section-agenda"
    }
  }, [_c('div', {
    staticClass: "s-title"
  }), _vm._v(" "), (_vm.agendaData.type[1]) ? _vm._l((_vm.agendaData.type[1]), function(key, index) {
    return _c('div', {
      class: 'agenda-item-' + index
    }, [_c('div', {
      staticClass: "conf-host",
      class: 'conf-host-' + index
    }, [_c('div', {
      staticClass: "title"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(key)
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "agenad-list"
    }, [_vm._l((_vm.agendaData.meeting[key]), function(agenda, index) {
      return [_c('agenda-item', {
        attrs: {
          "data": agenda,
          "index": index
        }
      })]
    })], 2)])
  }) : _vm._e()], 2)]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "section tickets"
  }, [_c('p', {
    attrs: {
      "id": "s-tickets"
    }
  }), _vm._v(" "), _vm._m(6), _vm._v(" "), (false) ? _c('span', {
    staticClass: "no-more-invoice"
  }, [_vm._v("12月20日之后将不再提供本次活动的发票")]) : _vm._e(), _vm._v(" "), (false) ? _c('a', {
    staticClass: "rogers-area",
    attrs: {
      "href": "https://jinshuju.net/f/Jlf1js",
      "target": "_blank"
    }
  }, [_vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "buy-btn"
  }, [_vm._v("\n                    立即购票\n                ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tickets-content"
  }, [_c('a', {
    staticClass: "ticket3",
    attrs: {
      "href": _vm.ticketUrl,
      "target": "_blank"
    }
  }, [_vm._m(9)]), _vm._v(" "), _c('a', {
    staticClass: "ticket0",
    attrs: {
      "href": _vm.ticketUrl,
      "target": "_blank"
    }
  }, [_vm._m(10)]), _vm._v(" "), _c('a', {
    staticClass: "ticket1",
    attrs: {
      "href": _vm.ticketUrl,
      "target": "_blank"
    }
  }, [_vm._m(11)]), _vm._v(" "), _c('a', {
    staticClass: "ticket2",
    attrs: {
      "href": _vm.ticketUrl,
      "target": "_blank"
    }
  }, [_vm._m(12)]), _vm._v(" "), (false) ? _c('a', {
    staticClass: "ticket3",
    attrs: {
      "href": _vm.ticketUrl,
      "target": "_blank"
    }
  }, [_vm._m(13)]) : _vm._e()])]), _vm._v(" "), (false) ? _c('div', {
    attrs: {
      "id": "old-guest-bg-area"
    }
  }, [_c('div', {
    staticClass: "section old-guests"
  }, [_c('p', {
    attrs: {
      "id": "s-old-guest"
    }
  }), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, _vm._l((_vm.oldGuests), function(item) {
    return _c('div', {
      staticClass: "old-guest-item"
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "guest-name"
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "guest-title"
    }, [_vm._v(" " + _vm._s(item.title))])])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "faq-bg-area"
    }
  }, [_c('div', {
    staticClass: "section faq"
  }, [_c('p', {
    attrs: {
      "id": "s-faq"
    }
  }), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "faq-item"
  }, [_vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), (false) ? _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                                是否可以申请发票？\n                            ")])]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _vm._m(20)]) : _vm._e(), _vm._v(" "), _vm._m(21), _vm._v(" "), (_vm.showMoreFaq) ? [_vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27)] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "faq-more-btn",
    on: {
      "click": function($event) {
        _vm.showMoreFaq = !_vm.showMoreFaq
      }
    }
  }, [(!_vm.showMoreFaq) ? _c('span', [_vm._v("查看更多")]) : _c('span', [_vm._v("点击收起")])])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "section partners"
  }, [_c('a', {
    attrs: {
      "name": "s-partners",
      "id": "s-partners"
    }
  }), _vm._v(" "), _vm._m(28), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('a', {
    attrs: {
      "name": "s-partners"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "up-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }), _vm._v(" "), _c('dl', [_vm._l((_vm.partnerList), function(partner) {
    return [_vm._l((partner), function(val, key) {
      return [_c('dt', [_vm._v(_vm._s(key))]), _vm._v(" "), _c('dd', _vm._l((val), function(pic) {
        return _c('img', {
          attrs: {
            "src": pic.logo + '-fintech.partner'
          }
        })
      }))]
    })]
  })], 2)])]), _vm._v(" "), _vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showBottomNav) ? _c('div', {
    staticClass: "bottom-buy-link-float"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(42)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-wrap"
  }, [_c('a', {
    staticClass: "bottom-nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-guest"
    }
  }, [_vm._v(" 确认嘉宾 ")]), _vm._v(" "), _c('a', {
    staticClass: "bottom-nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-agenda"
    }
  }, [_vm._v(" 大会议程 ")]), _vm._v(" "), _c('a', {
    staticClass: "bottom-nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": _vm.ticketUrl,
      "target": "_blank"
    }
  }), _vm._v(" "), (false) ? _c('a', {
    staticClass: "bottom-nav-link",
    attrs: {
      "target": "_blank",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": _vm.ticketUrl
    }
  }) : _vm._e()])]) : _vm._e()])], 1), _vm._v(" "), _vm._m(31)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "en"
  }, [_vm._v(" PAST GUEST")]), _vm._v(" "), _c('div', {
    staticClass: "zh"
  }, [_vm._v(" 往期嘉宾")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/5069.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(11)
    }
  })])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "empty"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/5072.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/5078.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(13)
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/1897.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(12)
    }
  })])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "empty"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/1916.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(14)
    }
  })])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": __webpack_require__(44)
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "en"
  }, [_vm._v("GUESTS")]), _vm._v(" "), _c('div', {
    staticClass: "zh"
  }, [_vm._v("确认嘉宾")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px",
      "padding-left": "10px"
    }
  }, [_vm._v("排名不分先后")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "en"
  }, [_vm._v(" AGENDA ")]), _vm._v(" "), _c('div', {
    staticClass: "zh"
  }, [_vm._v(" 大会议程 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "award-area"
    }
  }, [_c('p', {
    attrs: {
      "id": "s-award"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "section award"
  }, [_c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "en"
  }, [_vm._v(" AWARD ")]), _vm._v(" "), _c('div', {
    staticClass: "zh"
  }, [_vm._v(" 奖项评选 ")])]), _vm._v(" "), _c('div', {
    staticClass: "award-content"
  }, [_c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/explore/2018vote/#!/topstartups",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6)
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/explore/2018vote/#!/topvc",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(7)
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/explore/2018vote/#!/topinvestorunder30",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(8)
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/explore/2018vote/#!/topinvestorunder40",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(9)
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "participator-area"
    }
  }, [_c('div', {
    staticClass: "section tickets"
  }, [_c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "en"
  }, [_vm._v(" SAFF ANALYSIS ")]), _vm._v(" "), _c('div', {
    staticClass: "zh"
  }, [_vm._v(" 参会人群分析")])]), _vm._v(" "), _c('div', {
    staticClass: "participator-content"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("参会嘉宾")]), _vm._v(" "), _c('div', {
    staticClass: "count"
  }, [_vm._v(" 5000+")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("演讲嘉宾")]), _vm._v(" "), _c('div', {
    staticClass: "count"
  }, [_vm._v(" 100+")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("会议嘉宾")]), _vm._v(" "), _c('div', {
    staticClass: "count"
  }, [_vm._v(" 50+")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("榜单")]), _vm._v(" "), _c('div', {
    staticClass: "count"
  }, [_vm._v(" 4+")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("参展企业")]), _vm._v(" "), _c('div', {
    staticClass: "count"
  }, [_vm._v(" 60+")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("媒体")]), _vm._v(" "), _c('div', {
    staticClass: "count"
  }, [_vm._v(" 150+")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "en"
  }, [_vm._v(" TICKETS ")]), _vm._v(" "), _c('div', {
    staticClass: "zh"
  }, [_vm._v(" 参会购票 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rogers"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(45)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ticket-info"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                        尊享票\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "price-line"
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v(" 36666元")]), _vm._v(" "), _c('span', {
    staticClass: "count"
  }, [_vm._v(" 限10位名额")])]), _vm._v(" "), _c('div', {
    staticClass: "intro-line"
  }, [_c('ul', [_c('li', [_vm._v("闭门晚宴入场券")]), _vm._v(" "), _c('li', [_vm._v("将有机会与全球最强创投大脑")]), _vm._v(" "), _c('li', [_vm._v("亲密social ")]), _vm._v(" "), _c('li', [_vm._v("CEO 票所有权益")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ticket-item"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                            限时优惠票\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_vm._v("\n                          9.9元 \n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            2天通票，尽享3场论坛（主论坛除外），15+主题演讲 "), _c('br'), _vm._v("\n                            4000屏幕展览互动体验 "), _c('br'), _vm._v("\n                            限时特惠，数量有限 "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "bottom-area"
  }, [_c('div', {
    staticClass: "seat"
  }, [_vm._v(" 座位先到先得 ")]), _vm._v(" "), _c('div', {
    staticClass: "buy-btn"
  }, [_vm._v(" 立即购票 ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ticket-item"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(" 早鸟参会票 ")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_vm._v(" 99元  ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                          2天通票，尽享4场论坛，20+主题演讲 "), _c('br'), _vm._v("\n                          4000平米展览互动体验"), _c('br'), _vm._v("\n                          座位先到先得"), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "bottom-area"
  }, [_c('div', {
    staticClass: "seat"
  }, [_vm._v(" 有限席位 ")]), _vm._v(" "), _c('div', {
    staticClass: "buy-btn"
  }, [_vm._v(" 立即购票 ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ticket-item"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(" 2天峰会通票 ")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_vm._v(" 299元  ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                          2天通票，尽享4场论坛，20+主题演讲 "), _c('br'), _vm._v("\n                          4000平米展览互动体验"), _c('br'), _vm._v("\n                          座位先到先得"), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "bottom-area"
  }, [_c('div', {
    staticClass: "seat"
  }, [_vm._v(" 有限席位 ")]), _vm._v(" "), _c('div', {
    staticClass: "buy-btn"
  }, [_vm._v(" 立即购票 ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ticket-item"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(" CEO 票 ")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_vm._v(" 999元  ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            2天通票，尽享4场论坛，20+主题演讲"), _c('br'), _vm._v("\n                            4000平米展览互动体验"), _c('br'), _vm._v("\n                            保证前排座位"), _c('br'), _vm._v("\n                            演讲嘉宾可公开 PPT 独家分享"), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "bottom-area"
  }, [_c('div', {
    staticClass: "seat"
  }, [_vm._v(" 有限席位仅限CEO参加 ")]), _vm._v(" "), _c('div', {
    staticClass: "buy-btn"
  }, [_vm._v(" 立即购票 ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ticket-item"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(" 晚宴入场券 ")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_vm._v(" 9999元  ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            闭门晚宴入场券"), _c('br'), _vm._v("\n                            将有机会与全球最强创投"), _c('br'), _vm._v("\n                            大脑亲密social "), _c('br'), _vm._v("\n                            CEO 票所有权益"), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "bottom-area"
  }, [_c('div', {
    staticClass: "seat"
  }, [_vm._v(" 有限席位，报名需审核 ")]), _vm._v(" "), _c('div', {
    staticClass: "buy-btn"
  }, [_vm._v(" 立即购票 ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(16)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "en"
  }, [_vm._v(" FAQ ")]), _vm._v(" "), _c('div', {
    staticClass: "zh"
  }, [_vm._v(" 参会指南 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                                购票什么时候截止?\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                                购票截止日期为2018年11月12日。\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                                购票付款成功后，如何获得参会凭证？\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                                在您成功付款后，您将收到短信提醒，内容包含参会信息及电子票二维码，活动时凭电子票二维码入场。 "), _c('br'), _vm._v("\n                                活动开始前一周，还会短信发送一次参会信息。如果您关注了不凡商业（微信号：bufanbiz），届时也会有相应的提醒。\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                                当您的购票订单付款成功后，会有相应的申请发票入口。也可 "), _c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": "http://www.xfz.cn/order/",
      "target": "_blank"
    }
  }, [_vm._v("点此申请发票")]), _vm._v("，在相应的订单下方点击申请发票即可。\n                            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-a"
  }, [_c('div', {
    staticClass: "sa-title"
  }, [_vm._v("温馨提示：")]), _vm._v(" "), _c('div', {
    staticClass: "sa-content"
  }, [_vm._v("\n                                1) 大会门票仅开具增值税普通发票，不提供增值税专用发票；"), _c('br'), _vm._v("\n                                2) 开票内容为：会议服务费 "), _c('br'), _vm._v("\n                                3) 因本公司每月增值税普通发票数量有限，将以申请开票的先后顺序开具并安排快递，不保证当月开票，请谅解。"), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                                观众座位是否有预留？会议现场是否需要对号入座，会议中途离开，座位是否保留？\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                                请您核对票务权益，早鸟票、峰会通票用户根据进场顺序安排，不确保坐席，如您中途离开会场，不确保保留座位。\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                                大会现场有同声传译服务吗？如何领取同传设备？\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                                有，活动当天请凭借本人身份证，到指定地点换区同传设备，活动结束后，请及时归还同传设备并取回身份证。\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                                大会场馆附近有就餐的地方吗？\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                                酒店6层设有自助餐厅；距会场2-7分钟，步行即可到达诸多卖场，中餐、西餐、港式餐厅等，价位不等，有多样选择。\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "en"
  }, [_vm._v(" PARTNERS ")]), _vm._v(" "), _c('div', {
    staticClass: "zh"
  }, [_vm._v(" 合作机构 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section location"
  }, [_c('a', {
    attrs: {
      "name": "s-location",
      "id": "s-location"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "en"
  }, [_vm._v(" ADDRESS ")]), _vm._v(" "), _c('div', {
    staticClass: "zh"
  }, [_vm._v(" 会议地址 ")])]), _vm._v(" "), _c('div', {
    staticClass: "location-wrap"
  }, [_c('div', {
    staticClass: "address-info"
  }, [_c('div', [_vm._v("\n                        会场地址：国贸站 G 东南口出，890 米即到\n                    ")]), _vm._v(" "), _c('div', [_vm._v("\n                        地铁路线：大望路站 D 西北口出，649 米即到\n                    ")]), _vm._v(" "), _c('div', [_vm._v("\n                        驾车路线：北京市朝阳区建外大街建国路93号万达广场 C 座\n                    ")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(43)
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section about-us"
  }, [_c('a', {
    attrs: {
      "name": "s-contact-us",
      "id": "s-contact-us"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "25px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "en"
  }, [_vm._v(" CONTACT US")]), _vm._v(" "), _c('div', {
    staticClass: "zh"
  }, [_vm._v(" 联系我们 ")])]), _vm._v(" "), _c('div', {
    staticClass: "about-us-wrap"
  }, [_c('div', {
    staticClass: "user-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("赞助合作")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("李成坤")]), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_vm._v("138-1187-2225")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_vm._v("chengkun@bufanbiz.com")])]), _vm._v(" "), _c('div', {
    staticClass: "user-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("媒体合作")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("赵子悠")]), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_vm._v("185-4513-1578")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_vm._v("zhaobo@bufanbiz.com")])]), _vm._v(" "), _c('div', {
    staticClass: "user-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("报名咨询")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("罗阳")]), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_vm._v("188-1179-5758")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_vm._v("luoyang@bufanbiz.com")])]), _vm._v(" "), _c('div', {
    staticClass: "qrcode"
  }, [_c('img', {
    attrs: {
      "src": "https://www.bufanbiz.com/static/build/images/footer-wx-share.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "qrcode-info"
  }, [_c('span', [_vm._v("扫描二维码"), _c('br'), _vm._v(" 关注不凡商业")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "new-buy-link-float"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "https://www.bufanbiz.com/explore/bufan2018/news/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(10)
    }
  })])])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ticket-item"
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#fff"
    },
    attrs: {
      "href": "http://www.xfz.cn/apply/conference/?code=pYTHCKmwD9",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "type"
  }, [_vm._v(" " + _vm._s(_vm.data.type) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "price",
    class: {
      'break-word': _vm.data.price == '￥399'
    }
  }, [_vm._v(" " + _vm._s(_vm.data.price))]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(" " + _vm._s(_vm.data.info) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "buy"
  }, [_vm._v(" 购票 ")])])])
},staticRenderFns: []}

/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "top-seciton"
    }
  }, [_vm._v("\n    hello top seciton         \n    "), _c('div', {
    staticClass: "test"
  }, [_vm._v("\n       test green \n    ")])])
}]}

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-ticket-item"
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#fff"
    },
    attrs: {
      "href": "http://www.xfz.cn/apply/conference/?code=pYTHCKmwD9",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "type"
  }, [_vm._v(" " + _vm._s(_vm.data.type) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "price",
    class: {
      'break-word': _vm.data.price == '￥399'
    }
  }, [_vm._v(" " + _vm._s(_vm.data.price))]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(" " + _vm._s(_vm.data.info) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "buy"
  }, [_vm._v(" 购票 ")])])])
},staticRenderFns: []}

/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['agenda-item', {
      'agenda-item-bg-reverse': _vm.index % 2 == 0
    }]
  }, [_c('div', {
    staticClass: "item-wrap",
    class: {
      'one-width': _vm.data.speaker.length == 1 || _vm.data.speaker.length == 0, 'double-width': _vm.data.speaker.length == 2, 'triple-width': _vm.data.speaker.length == 3
    }
  }, [_c('div', {
    staticClass: "agenda-title"
  }, [_c('div', {
    staticClass: "t-name"
  }, [_c('div', [_vm._v(_vm._s(_vm.data.time.split('~')[0]))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "-6px 0"
    }
  }, [_vm._v("~")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.data.time.split('~')[1]))])]), _vm._v(" "), _c('div', {
    staticClass: "triangle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "a-content"
  }, [(!_vm.data.speaker[0] || !_vm.data.speaker[0].photo) ? _c('div', {
    staticClass: "space"
  }) : _vm._e(), _vm._v(" "), (_vm.data.speaker[0] && _vm.data.speaker[0].photo) ? _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "name-title"
  }, [(_vm.data.speaker[0].photo) ? _c('div', {
    staticClass: "photo"
  }, [_c('img', {
    attrs: {
      "src": _vm.data.speaker[0].photo
    }
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('p', {
    staticClass: "subject-type"
  }, [_vm._v(_vm._s(_vm.data.subject.split('|')[0]))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "subject-title"
  }, [_vm._v(" " + _vm._s(_vm.data.subject.split('|')[1]))])])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "divider-line"
  }) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 62 */,
/* 63 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[27]);


// WEBPACK FOOTER //
// static/js/app.f50cb93a7fa85ce99d9d.js